import { LazyMapsAPILoaderConfigLiteral } from '@agm/core';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/modules/core/services/config.service';

@Injectable()
export class GoogleMapsConfig implements LazyMapsAPILoaderConfigLiteral {
	apiKey: string;

	constructor(private configService: ConfigService) {
		this.configService.configObservable.subscribe((config) => {
			if (config) {
				this.apiKey = config.googleMapsApiKey;
			}
		});
	}
}
